import React from 'react';
import { Schema } from '../../toolympus/hooks/useSchema';
import { NewItemProps } from '../../toolympus/api/useNewItem';
import { FormGrid, SimpleDialog } from '../../toolympus/components/primitives';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { Document } from './useDocumentsList';

interface Props extends NewItemProps<Partial<Document>, Document> {
  schema: Schema;
}

export const CreateDocumentDialog = (props: Props) => {
  const { isEditing, cancel, errors, item, update, save, schema } = props;
  return (
    <SimpleDialog
      isOpen={isEditing}
      close={cancel}
      dialogTitle="Новый документ"
      submitOnModEnter
      save={() => save()}>
      {item && <FormGrid columns="1fr">
        <FormControlsForFields
          fields={[
            ["title"],
            ["document_type"],
            ["document_date"],
          ]}
          data={item}
          onChange={(o,c) => update(c)}
          errors={errors}
          schema={schema}
          />
      </FormGrid>}
    </SimpleDialog>
  );
}

